import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-confirmation-dialogue",
    templateUrl: "./confirmation-dialogue.component.html",
    styleUrls: ["./confirmation-dialogue.component.scss"],
})
export class ConfirmationDialogueComponent implements OnInit {
    formData: any;
    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogueComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {}

    onRemove(num) {
        this.dialogRef.close(num);
    }
}
